import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useResendVerificationEmailMutation } from "../../redux/slices/authApiSlice";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { ButtonAuth } from "../../components/auth";

const ExpiredLink = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const uid = searchParams.get("uid");

  const [resendVerificationEmail, { isLoading }] = useResendVerificationEmailMutation();

  const handleResendVerificationEmail = async () => {
    if (!uid) {
      toast.error("Identifiant introuvable dans l'URL.");
      return;
    }

    try {
      const res = await resendVerificationEmail({ uid }).unwrap();
      if (res.status_code === 200) {
        toast.info("Un nouvel email de validation a été envoyé !");
      }
    } catch (error) {
      toast.error(error?.data?.detail || "Une erreur s'est produite.");
    }
  };

  return (
    <div className="space-y-6">
      <Helmet>
        <title>{t("expired-link", "Votre lien de confirmation a expiré")} | BotBlogR</title>
        <meta name="description" content="Page de lien de confirmation expiré." />
      </Helmet>

      <p>{t("expired-confirmation-link", "Le lien de confirmation a expiré. Vous pouvez cliquer ci-dessous pour recevoir un nouveau lien.")}</p>

      <ButtonAuth
        action={handleResendVerificationEmail}
        disabled={isLoading}
        isLoading={isLoading}
        type="submit"
        text={t("resend-verification-email", "Renvoyer l'email de vérification")}
      />
    </div>
  );
};

export default ExpiredLink;